import React, { useEffect, useState, useContext } from 'react';
import { 
  Col,
  Container, 
  Row, 
  Modal,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Card, CardBody } from '@/shared/components/Card';
import toast from 'react-hot-toast';
import { FaRegUser } from 'react-icons/fa6';
import { MdOutlineMailOutline, MdOutlineMapsHomeWork } from 'react-icons/md';
import { IoLocationOutline } from 'react-icons/io5';
import { FaPhoneAlt, FaBraille } from 'react-icons/fa';
import { Button } from '@/shared/components/Button';
import CryptoJS from 'crypto-js';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import { RestaurantContext } from '../../../../context/RestaurantContext';
import LocationDetails from './LocationDetails';
import EditPrimary from './EditPrimary';
import AddRestaurantLocation from './AddRestaurantLocation';
import { PermissionContext } from '../../../../context/PermissionContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';
import { AuthContext } from '../../../../context/AuthContext';


const ResaurantDetails = ({ restaurantid }) => { 
  const [restaurantdata, setRestaurantData] = useState([]);
  const [showModalcontact, setShowModalcontact] = useState(false);
  const { userid, setCurrencyCode, countryId } = useContext(AuthContext);
  const [refresh, setRefresh] = useState(false);
  const [showModalLocation, setShowModalLocation] = useState(false);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { setRestaurantInfo, restaurantInfo } = useContext(RestaurantContext);
  const { permissionsAccess } = useContext(PermissionContext);
  const [loading, setLoading] = useState(false);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);

  // if (!restaurantid) {
  //   toast.error('id not found');
  // }

  // const getCurrencyCode = async (countryId) => {
  //      const formData = new FormData();
  //      formData.append('country_id', countryId);
  //       try {
  //         const url = await fetch(`${apiGlobal}/get_currency_code.php`, {
  //           method: 'POST',
  //           body: formData,
  //         });
  //         const response = await url.json();
  //         if (response?.status && response?.message === 'Success') {
  //           const currencyCode = response.data?.currency_name;
  //           // const currencyType = countryId;
  //           setCurrencyCode(currencyCode);
  //           // setCurrencyType(currencyType); // currency id
  
       
  //          const encryptedCurrencyCode = CryptoJS.AES.encrypt(
  //         currencyCode.toString(),
  //         'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
  //       ).toString();
  //       localStorage.setItem('99117114114101110991219599111100101', encryptedCurrencyCode);
  //         } else {
  //           console.log(response?.message);
  //         }
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     };

  const fetchData = async () => {
    if (!restaurantid) {
      toast.custom('Loading...Data fetching');
      // toast.i('No restaurant selected!');
      return;
    }
     const formData = new FormData();
     formData.append('id', restaurantid);
       formData.append('country_id', countryId);
    try {
      const response = await fetch(`${apiGlobal}/restaurant_data_fetch.php`, {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
  
      const data = await response.json();
      // console.log(data);
      if (data?.status && data?.message === 'Success') {
        setRestaurantData(data?.data[0] || []);
      } else {
        toast.error('Failed to fetch restaurant data');
        setRestaurantData([]);
      }
    } catch (error) {
      toast.error('Error fetching restaurant details');
    }
  };
  
  useEffect(() => {
    fetchData();
  }, [restaurantid, sideBarRefresh?.restaurantProfileRefresh]);

  // const isMounted = true;

  // const fetchData = async () => {
  //   if (!restaurantid) {
  //     toast.error('No restaurant selected!');
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${apiGlobal}/restaurant_data_fetch.php?id=${restaurantid}`,
  //     );
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch data');
  //     }

  //     const data = await response.json();
  //     if (data?.status && data?.message === 'Success') {
  //       if (isMounted) {
  //         setRestaurantData(data?.data[0] || []);
  //         setRefresh(prev => !prev);
  //       }
  //     } else {
  //       toast.error('Failed to fetch restaurant data');
  //       if (isMounted) {
  //         setRestaurantData([]);
  //       }
  //     }
  //   } catch (error) {
  //     toast.error('Error fetching restaurant details');
  //   }
  // };

  // useEffect(() => {
  //   fetchData(restaurantid);
  // }, [restaurantid]);


  const onAddContactInfo = () => {
    setShowModalcontact(true);
  };
  const onAddLocation = () => {
    setShowModalLocation(true);
  };

  const onEditContactSubmit = async (values) => {
   // console.log(JSON.stringify(values, null, 2));
    const formData = new FormData();
   
    // console.log(values.acccountry);

    formData.append('id', restaurantid);
    formData.append('user_name', values.user_name);
    formData.append('user_phone', values.user_phone);
    formData.append('country_code', values.country_code_id);
    formData.append('user_email', values.user_email);
    formData.append('uin', values.uin);
    formData.append('country', values.country);
    formData.append('acc_name', values.acc_name);
    formData.append('acc_country', values.acc_country);
    formData.append('account_no', values.account_no);
    formData.append('acc_city', values.acc_city);
    formData.append('branch', values.branch);
    formData.append('ifsc_code', values.ifsc_code);
    formData.append('bank', values.bank);
    formData.append('photo', values.file);


    formData.append('type', 2);
    formData.append('user_id', userid);

    // formData.forEach((value, key) => {
    //   console.log(`${key}: ${value}`);
    // });

       try {
        setLoading(true);
           const url = await fetch(`${apiGlobal}/restaurant_edit.php`, {
            method: 'POST',
            body: formData,
           });
            const response = await url.json();
            if (response?.status && response?.message === 'Data updated successfully.') {
                toast.success('Data updated successfully.');
                setShowModalcontact(false);
                // getCurrencyCode(values.country);
                fetchData();
                setLoading(false);
            } else {
                toast.error(response?.message);
            }
       } catch (error) {
           toast.error(error.message);
       } finally {
        setLoading(false);
        }
  };


  const onAddLocationSubmit = async (values) => {
     // console.log(`You submitted:\n\n${JSON.stringify(values, null, 2)}`);

    // convert time into ist Standared
    const utcStartTime = new Date(values.fromTime);
// Convert to IST and format it to "HH:mm" (24-hour format)
const formattedStartTime = utcStartTime.toLocaleTimeString('en-IN', {
  timeZone: 'Asia/Kolkata',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const utcEndTime = new Date(values.toTime);
// Convert to IST and format it to "HH:mm" (24-hour format)
const formattedEndTime = utcEndTime.toLocaleTimeString('en-IN', {
  timeZone: 'Asia/Kolkata',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false, 
});

// console.log(formattedStartTime); 
// console.log(formattedEndTime); 

    

     const mealOffered = [];
     const mealFormat = [];

     if (values.fit) {
        mealFormat.push('1');
     }
     if (values.git) {
        mealFormat.push('2');
     }
     if (values.delivery) {
        mealFormat.push('3');
     }


    if (values.breakfast) {
        mealOffered.push('1');
    }
    if (values.snacks) {
        mealOffered.push('2');
    }
    if (values.lunch) {
        mealOffered.push('3');
    }
    if (values.dinner) {
        mealOffered.push('4');
    }

    if (mealFormat.length === 0) {
      toast.error('Atleast select one meal format');
      return;
    }
    
    if (mealOffered.length === 0) {
      toast.error('Atleast select one meal offered');
      return;
    }
    
    if (formattedStartTime === 'Invalid Date' || formattedEndTime === 'Invalid Date') {
      toast.error('Select Valid Start And End Time');
      return;
    }

    if (!restaurantInfo.latitude || !restaurantInfo.longitude || !restaurantInfo.maplink) {
      toast.error('Please select a restaurant location co-ordinates');
      return;
    }

    const formData = new FormData();
    formData.append('restaurant_id', restaurantid);
    formData.append('name', values.restaurantName); 
    formData.append('address1', values.address1); 
    formData.append('area', values.area); 
    formData.append('state', values.state); 
    formData.append('pincode', values.pincode); 
    formData.append('description', values.discription); 
    formData.append('photo', values.logo); 
    formData.append('setting_capacity', values.settingCap); 
    formData.append('capping_capacity', values.capCapacity); 
    formData.append('uin', values.uin);
    formData.append('address2', values.address2); 
    formData.append('city', values.city); 
    formData.append('country', values.country); 
    formData.append('cuisines', values.cuisines); 
    formData.append('start_time', formattedStartTime); 
    formData.append('end_time', formattedEndTime); 
    formData.append('latitude', restaurantInfo.latitude); 
    formData.append('longitude', restaurantInfo.longitude); 
    formData.append('map_location', restaurantInfo.maplink); 
    formData.append('location', values.location); 
    formData.append('tax_id', values.taxID); 
    formData.append('markup_percentage', 0); 
    formData.append('meal_offered', mealOffered.join(',')); 
    formData.append('meal_format', mealFormat.join(','));  


    formData.append('type', 2);
    formData.append('user_id', userid);
    
  //   formData.forEach((value, key) => {
  //     // console.log(`${key}: ${value}`);
  // });


    try {
      setLoading(true);
        const response = await fetch(`${apiGlobal}/restaurant_location_add.php`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) {
            console.log(`Network response was not ok: ${response.statusText}`);
        }
        const responseData = await response.json();
        if (responseData?.status && responseData?.message === 'Data inserted successfully.') {
            toast.success('Restaurant Location Added Successfully...');
            setRefresh(prev => !prev);
            setRestaurantInfo({
              latitude: '',
              longitude: '',
              maplink: '',
            });
            setShowModalLocation(false);
            setLoading(true);
        } else {
            toast.error(responseData?.message);
        }
    } catch (error) {
        toast.error(error.message);
    } finally {
      setLoading(false);
      }
  };


  const hideaddlocationModal = () => {
    setRestaurantInfo({
      latitude: '',
      longitude: '',
      maplink: '',
    });
    setShowModalLocation(false);
  };

 

  return (
    <Container>
     

      <Row>
        <Col xs={12} md={12}>
          <Card>
            <CardBody>
              {permissionsAccess?.[0]?.master_id === '1'
                  && permissionsAccess?.[0]?.edit === 1 && (
                    <div style={{ float: 'right' }}>
                      <Button variant="primary" size="sm" onClick={onAddContactInfo}>Edit</Button>
                    </div>
                  )}
              
              <div className="row">
                <div className="col-md-12">
                  <div className="restaurantname">
                    <h2> {restaurantdata?.name}</h2>
                  </div>
                  <div className="restaurantPrimaryData">
                    <div className="row">
                      <div className="col-md-12">
                        <h5 style={{ marginTop: '10px', fontWeight: 'bold' }}>Primary Contact Details</h5>
                      </div>
                      <div className="col-md-12" style={{ marginTop: '10px' }}>
                        <div className="row">
                          <div className="col-md-3">
                            <FaRegUser /> Name : {restaurantdata?.user_name}
                          </div>
                          <div className="col-md-3">
                            <MdOutlineMailOutline /> Email : {restaurantdata?.user_email}
                          </div>
                          <div className="col-md-3">
                            <FaPhoneAlt />{' '}Phone No : {restaurantdata?.country_code} {restaurantdata?.user_phone}
                          </div>
                          {/* <div className="col-md-3">
                            <FaPhoneAlt />{' '}Phone No : {restaurantdata?.user_phone}
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="restaurantAccountData">
                    <div className="row">
                      <div className="col-md-12">
                        <h5 style={{ marginTop: '10px', fontWeight: 'bold' }}>Account Details</h5>
                      </div>
                      <div className="col-md-12" style={{ marginTop: '10px' }}>
                        <div className="row">
                          <div className="col-md-3">
                            <FaRegUser />{' '}Acc Name : {restaurantdata?.acc_name}
                          </div>
                          <div className="col-md-3">
                            <FaBraille />{' '}AC # : {restaurantdata?.account_no}
                          </div>
                          <div className="col-md-3">
                            <FaBraille />{' '}IFSC : {restaurantdata?.ifsc_code}
                          </div>
                          <div className="col-md-3">
                            <MdOutlineMapsHomeWork />{' '}Bank : {restaurantdata?.bank}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12" style={{ marginTop: '10px' }}>
                        <div className="row">
                          <div className="col-md-3">
                            <IoLocationOutline />{' '}Branch : {restaurantdata?.branch}
                          </div>
                          <div className="col-md-3">
                            <IoLocationOutline />{' '}City : {restaurantdata?.acc_city}
                          </div>
                          <div className="col-md-3">
                            <IoLocationOutline />{' '}Country : {restaurantdata?.country_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12}>
          {permissionsAccess?.[0]?.master_id === '1'
                  && permissionsAccess?.[0]?.create === 1 && (
                    <div style={{ float: 'right' }}>
                      <Button variant="primary" size="sm" onClick={onAddLocation}>Add Location</Button>
                    </div>
                  )}
          <Card style={{ height: '93%' }}>
            <CardBody>
              <div className="row">
                <div className="col-md-12">
                  <LocationDetails 
                    restaurantDetailsId={restaurantid}
                    refresh={refresh}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal show={showModalcontact} onHide={() => setShowModalcontact(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Primary Information
            {/* <Button variant="outline-primary" className="mx-4" onClick={onPasswordBtn}>Change Password</Button> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <EditPrimary 
            onSubmit={onEditContactSubmit}
            restaurantDetailsId={restaurantid}
            loading={loading}
            setShowModalcontact={setShowModalcontact}
          />
          {/* <PrimaryContactForm
            onSubmit={onEditContactSubmit}
            restaurantDetailsId={restaurantDetailsId}
          /> */}
        </Modal.Body>
      </Modal>
      <Modal show={showModalLocation} onHide={hideaddlocationModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Location
            {/* <Button variant="outline-primary" className="mx-4" onClick={onPasswordBtn}>Change Password</Button> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddRestaurantLocation
            restaurantname={restaurantdata?.name} 
            onSubmit={onAddLocationSubmit}
            loading={loading}
          />

          {/* <AddLocation
            onSubmit={onAddLocationSubmit}
            
          /> */}
        </Modal.Body>
      </Modal>
    </Container>
);
};


ResaurantDetails.propTypes = {
  restaurantid: PropTypes.string.isRequired,
};

export default ResaurantDetails;
